/* eslint no-unused-vars: 0 */
import { StyleValue } from "vue";

export enum ContentIndexTypeEnum {
  default = "default",
  circle = "circle",
  index = "index",
  brackets = "brackets",
}

export enum ContentTypeEnum {
  default = "default",
  link = "link",
  image = "image",
  tip = "tip",
  "tip-link" = "tip-link",
  table = "table",
  api = "api",
  "demo-video" = "demo-video",
  "code-sample" = "code-sample",
}

export enum TitleTypeEnum {
  default = "default",
  danger = "danger",
}

export enum TitleLevelEnum {
  first = "first",
  second = "second",
  third = "third",
  huge = "huge",
}

export interface IStaticTitle {
  text: string;
  titleIndex?: string;
  type?: TitleTypeEnum;
  level?: TitleLevelEnum;
  styleObject?: StyleValue;
  hasBorder?: boolean;
}

export interface IImage {
  spUrl: string;
  pcUrl: string;
  spWidth: string;
  spMaxWidth: string;
  pcWidth: string;
  pcMaxWidth: string;
  title?: string;
  type?: ImageTypeEnum;
}

export enum ImageTypeEnum {
  default = "default",
  danger = "danger",
}

export interface ICodesTipItem {
  label: string;
  name: string;
  content: string;
}

export enum VideoTypeEnum {
  default = "default",
  danger = "danger",
}

export interface ITableColumn {
  prop: string;
  label: string;
  width?: string;
}

export enum ITableDataIndexType {
  default = "default",
  circle = "circle",
}

export interface ITableDataColumnItem {
  indexType?: ITableDataIndexType;
  text: string;
}

export interface ITableData {
  [prop: string]: Array<ITableDataColumnItem>;
}

export interface ITableDataItem {
  column: Array<ITableColumn>;
  data: Array<ITableData>;
}

export interface ITable {
  pcTable: ITableDataItem;
  spTable: Array<ITableDataItem>;
}

export interface IStaticContent {
  text?: string;
  indexText?: string;
  indexType?: ContentIndexTypeEnum;
  type?: ContentTypeEnum;
  link?: string;
  image?: IImage;
  codes?: ICodes;
  styleObject?: StyleValue;
  table?: ITable;
  isDanger?: boolean;
  title?: string;
}

export interface ICodes {
  pcList: Array<ICodesTipItem>;
  pcWidth: string;
  pcMaxWidth: string;
  spList: Array<ICodesTipItem>;
  spWidth: string;
  spMaxWidth: string;
}

export interface IStaticData {
  title?: IStaticTitle;
  content?: Array<IStaticContent>;
  children?: Array<IStaticData>;
}

export interface IStaticContext {
  headerTitle: string;
  headerIcon: string;
  data: IStaticData[];
}

export interface TermApiContext {
  headerTitle: string;
  headerIcon: string;
  data: IStaticContent[];
}
export interface NoteData {
  release_date: string;
  note: string;
}

export interface IStaticNote {
  headerTitle: string;
  headerIcon: string;
  data: NoteData[];
}

// インデックスページ
export interface ICaseStudy {
  // 事例ID
  id: string;
  // タイトル
  title: string;
  // アイキャッチ画像のURL
  image: string;
  // home page
  home_image: string;
  // case study page
  case_home_image: string;
  // 取材日
  create_at?: string;
  // 会社情報
  company: {
    info: Array<{
      // 会社名称
      name: string;
      // ホームページのURL
      url?: string;
      // 関係者情報配列
      persons?: Array<{
        // 役職
        position?: string;
        // 名前
        name?: string;
      }>;
    }>;
    // 関係者情報として紹介会社の人たちの写真
    image?: string;
    // 会社紹介
    introduction?: string;
  };
  // プロローグ
  prologue?: string;
  // 本文配列
  articles?: Array<{
    // タイプ（headline：見出し、question：質問、body：本文、image：画像）
    type?: string;
    // テキスト　※HTML指定可能
    text?: string;
    // 画像のURL　※タイプが「body」または「image」の場合のみ有効
    image?: string;
    // 画像の位置（left：左、right：右）　※タイプが「body」の場合のみ有効、デフォルトは「right」
    image_align?: string;
    image_title?: string;
  }>;
  // 導入目的
  purposes?: Array<string>;
  // 導入した結果
  results?: Array<string>;
  // 利用しているAPI
  apis?: Array<string>;
  // なぜセーフィーに決めたか
  reasons?: Array<string>;
}
